/**
 * Renders Static Component when no dealership is found
 */

import { StyledDiv } from './GlobalError.style';

const GlobalError: React.FC = () => {
    return (
        <StyledDiv>
            <h1>Application ran into error</h1>
            <p data-testid="app-error">Application failed to bootstrap.</p>
        </StyledDiv>
    );
};

export default GlobalError;
